import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";

const links = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/category/jewellery", label: "Jewellery" },
  { to: "/category/lifestyle", label: "Lifestyle" },
  { to: "/faq", label: "FAQ" },
  { to: "/about-us", label: "About" },
  { to: "/contact-us", label: "Contact" },
];

export default function Navbar() {
  const { count, setOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const [mobile, setMobile] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setMobile(false), [loc.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "ee-glass border-b ee-hairline py-4" : "py-6 bg-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center">
          <img src="/images/ee-logo.png" alt="Equine Evolve" className="h-9 md:h-11 w-auto object-contain" />
        </Link>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`text-sm tracking-wide whitespace-nowrap transition-colors duration-300 hover:text-[#D4AF37] ${
                loc.pathname === l.to ? "text-[#D4AF37]" : "text-[#A8A29E]"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-5">
          <button
            data-testid="cart-toggle"
            onClick={() => setOpen(true)}
            className="relative text-[#FAFAF9] hover:text-[#D4AF37] transition-colors"
            aria-label="Open cart"
          >
            <ShoppingBag strokeWidth={1} size={24} />
            {count > 0 && (
              <span
                data-testid="cart-count"
                className="absolute -top-2 -right-2 bg-[#D4AF37] text-[#0C0A09] text-[10px] font-semibold rounded-full h-4 w-4 flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </button>
          <button
            className="lg:hidden text-[#FAFAF9]"
            onClick={() => setMobile((m) => !m)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {mobile ? <X strokeWidth={1} /> : <Menu strokeWidth={1} />}
          </button>
        </div>
      </div>

      {mobile && (
        <nav className="lg:hidden ee-glass border-t ee-hairline mt-4 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              className="text-[#A8A29E] hover:text-[#D4AF37] text-lg font-display tracking-wide"
            >
              {l.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}
